import React, { useState, useContext, useEffect } from 'react';
import { useParams } from "react-router-dom";
import {localizeKey, localizeArt} from './../localize.js';
import axiosInstance from './../axiosInstance.js';
import MyUserContext from './../myUserContext.js';
import Collapsible from './Collapsible';
import { Link } from 'react-router-dom';
import ShareButton from './ShareButton';
import LinkInput from './LinkInput';
import ExpandableImage from './ExpandableImage';

const TextUserPair = ({user, userId, hideRecomInput}) => {
  const myUser = useContext(MyUserContext);

  const [curUser, setCurUser] = useState(user);

  const [inputText, setInputText] = useState('');

  // Status of recent recommendation.
  const [errText, setErrText] = useState(null);

  const [successText, setSuccessText] = useState(null);
  const [successResp, setSuccessResp] = useState(null);

  const fetchCurUser = () => {
    axiosInstance
    .get(`/users/${userId}`)
    .then((response) => {
      setCurUser(response.data);
    })
    .catch((error) => {
      console.error(error);
    });
  };

  const handleRecommend = (userId, link) => {
    axiosInstance
    .post('/postRecommendation', { toUserId: userId, wikiArticleLink: link })
    .then((response) => {
      setSuccessText(localizeKey('recommendationPostSuccess', language));
      setErrText(null);
      setSuccessResp(response.data);
      setInputText("");
    })
    .catch((error) => {
      setErrText(error.response.data);
      setSuccessText(null);
      setSuccessResp(null);
    });
  }

  const handleFollow = () => {
    let verb = "follow";
    if (curUser.followedByMeState === "approved" || curUser.followedByMeState === "requested") {
      verb = "unfollow";
    }
    axiosInstance
    .post(`users/${curUser.id}/${verb}`, {})
    .then((response) => {
      setCurUser(response.data);
    })
    .catch((error) => {
      console.error(error);
    })
  }
  const renderButtonTextLocalizeKey = (followedByMeState) => {
    switch(followedByMeState) {
      case 'none':
        return 'follow';
      case 'requested':
        return 'requested';
      case 'approved':
        return 'approved';
      default:
        console.log.error("undefined followedByMeState");
        return "undefined";
    }
  }

  const handleApproveFollow = () => {
    axiosInstance
    .post(`users/${curUser.id}/respondToFollowRequest`, { decision : "approve" })
    .then((response) => {
      setCurUser(response.data);
    })
    .catch((error) => {
      console.error(error);
    })
  }
  const handleRejectFollow = () => {
    axiosInstance
    .post(`users/${curUser.id}/respondToFollowRequest`, { decision : "reject" })
    .then((response) => {
      setCurUser(response.data);
    })
    .catch((error) => {
      console.error(error);
    })
  }

  if (!curUser) {
    fetchCurUser();
    return <div></div>;
  }

  const language = myUser ? myUser.myUserSettings.lang : 'ru';

  return (
    <div>
      <div class="flex items-center">
        <Link to={`/users/${curUser.id}/likes`}>
          <ExpandableImage src={curUser.avatarUrl} />
        </Link>
        &nbsp;&nbsp;
        <div class="">
          <Link class="flex items-center text-center" to={`/users/${curUser.id}/likes`}>
            <p className="text-base font-semibold leading-6 hover:underline min-w-min">
              {curUser.userName + (myUser && myUser.myUserInfo.myUserId === curUser.id ? " (me)" : "")}                
            </p>
            {
            (myUser && curUser.followMeState === "approved") &&
              <>&nbsp;({ language==="ru" ? "подписан(а) на вас" : "follows you"})</>
            }
            {(myUser && curUser.id !== myUser.myUserInfo.myUserId && curUser.matchScore) &&
              <span className="ml-2 text-sm text-gray-400">
                &nbsp;
                {Math.floor(curUser.matchScore*100) + "%"}
              </span>
            }
          </Link>
          {
          (myUser && myUser.myUserInfo.myUserId !== curUser.id) && 
          <div onClick={handleFollow} class={(curUser.followedByMeState === "approved" || curUser.followedByMeState === "requested") ? "text-blue-700 " + "inline-block w-32 px-2 flex justify-center items-center max-h-7 text-center border-2 border-blue-700 rounded-lg hover:bg-slate-200 hover:border-blue-800 cursor-pointer" : "bg-blue-700 text-white " + "inline-block w-30 px-2 flext justify-center items-center max-h-7 text-center border-2 border-blue-700 rounded-lg hover:bg-blue-800 hover:border-blue-800 cursor-pointer"}>
            {localizeKey(renderButtonTextLocalizeKey(curUser.followedByMeState), language)}
          </div>
          }
        </div>
        {
        myUser &&
        <div class="-mt-1.5">
          {
          curUser.followMeState === "requested" &&
          <>
            <div>{language === "ru" ? "Хочет подписаться" : "Wants to follow"}</div>
            <div class="flex">
              <div onClick={handleApproveFollow} class={"bg-blue-700 text-white " + "px-2 flext justify-center items-center max-w-31 max-h-7 text-center border-2 border-blue-700 rounded-lg hover:bg-blue-800 hover:border-blue-800 cursor-pointer"}>
                Approve
              </div>              
              <div onClick={handleRejectFollow} class={"text-blue-700 " + "px-2 flext justify-center items-center max-w-31 max-h-7 text-center border-2 border-blue-700 rounded-lg hover:bg-slate-200 hover:border-blue-800 cursor-pointer"}>
                  Reject
              </div>
            </div>
          </>
          }
        </div>
        }
      </div>      
    </div>
  )
};

export default TextUserPair;